<div class="mb-5">
	<h1 class="h3 m-4">{{'utilization.charger_utilization_score' | translate}} <app-help-tooltip [field]="'chargLinkDevice.utilization_scores'"></app-help-tooltip></h1>
	<div class="chart-container">
		<div class="charts-row">
			<app-truck-utilization-charts
				[title]="'utilization.percent_utilization_score' | translate"
				[devices]="devices"
				[data]="utilizationScoreSelectedData"
				[deviceType]="chargerDeviceType"
				[selectedPeriod]="selectedPeriod"
				[xAxisColumnLabel]="'devices.of_total_chargers' | translate"
				modalDeviceType="chargers"
			></app-truck-utilization-charts>
			<app-truck-utilization-charts
				[title]="'utilization.percent_ah_score' | translate"
				[devices]="devices"
				[data]="chargerAhScoreSelectedData"
				[deviceType]="chargerDeviceType"
				[selectedPeriod]="selectedPeriod"
				[xAxisColumnLabel]="'devices.of_total_chargers' | translate"
				modalDeviceType="chargers"
			></app-truck-utilization-charts>
			<app-truck-utilization-charts
				[title]="'utilization.percent_kwh_score' | translate"
				[devices]="devices"
				[data]="chargerKwhScoreSelectedData"
				[deviceType]="chargerDeviceType"
				[selectedPeriod]="selectedPeriod"
				[xAxisColumnLabel]="'devices.of_total_chargers' | translate"
				modalDeviceType="chargers"
			></app-truck-utilization-charts>
		</div>
	</div>
</div>

